var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6576 14.8117L18.0423 11.0448C18.3177 10.7383 18.2925 10.2665 17.986 9.99109C17.6795 9.71566 17.2077 9.74087 16.9323 10.0474L4.7118 23.6476C4.43637 23.9541 4.46158 24.4259 4.76811 24.7013C5.07464 24.9767 5.54642 24.9515 5.82185 24.645L9.6458 20.3893L12.9507 23.6965C13.5752 24.3209 14.6576 23.8825 14.6576 22.9887V14.8117ZM14.6576 9.00065V10.1157L5.78385 19.9913H4.99915C4.73416 19.9913 4.48002 19.886 4.29264 19.6986C4.10527 19.5113 4 19.2571 4 18.9921V12.9972C4 12.7323 4.10527 12.4781 4.29264 12.2907C4.48002 12.1034 4.73416 11.9981 4.99915 11.9981H9.24553L12.9507 8.29292C13.5752 7.66845 14.6576 8.10683 14.6576 9.00065Z",
    fill: "url(#hinava_random_uuid_84415906391923459050829077664002754160)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_84415906391923459050829077664002754160",
    x1: 11.1167,
    y1: 8,
    x2: 11.1167,
    y2: 24.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.db372f62efb7f9f2b11c17c518c9c6ca.svg";
export { ForwardRef as ReactComponent };